
import axios from 'axios';
import {
  ASYNC_FETCH,
  ASYNC_FETCH_REVIEW_SUCCESS,
  ASYNC_FETCH_FAILURE,
  ASYNC_FETCH_INVALIDATE,
  SET_REVIEW_DATA,
  SET_ISREVIEW_LOAD,
  SET_ISCHANGE_PLAN,
} from '../constants';
import httpClient, { getHttpClientRequest, postHttpClientRequest, isUnAuth } from "../../../shared/services/httpClient";
import apiUrl from '../../../shared/utilities/apiUrl';
import { countryListAction } from '../../../shared/components/CountryListModal/actions';

export const getReviewSections = (postData,props, isEffectiveDate, isACSS,isPOS, planActions) => dispatch => {
  dispatch(asyncFetch());
  const onSuccess = response => {
    dispatch(asyncReviewCallStatus(response.data));
    
    if (response?.data?.body?.data?.confirmation) {
      props.remarksActions.setRemarksLoad(true);
      props.history.push("/itpconfirmation");
    }
  };
  const onError = (error, planActions) => {
    dispatch(asyncFetchFailed(error));

    let httpStatus = error?.response?.status;
    httpStatus = httpStatus ? httpStatus : error?.request?.status;
    httpStatus = httpStatus ? httpStatus : error?.response?.request?.status;
    if (httpStatus == 512) {
      planActions.setStopApiCall(true);
    }
  };
  const callMS = (postData, isEffectiveDate) => {
    var axConfig = {
      headers: { pageName: "reviewpage", subServiceName: "reviewpage" }
    };
    if (apiUrl().itpreviewPlansUrl.indexOf("localhost") > -1) {
      return getHttpClientRequest(apiUrl().itpreviewPlansUrl, axConfig);
    } else {
      let sApiUrl;
      if (postData?.goBack == "Y") {
        sApiUrl = isUnAuth() ? apiUrl().itpreviewPlansUrl_ua : apiUrl().itpreviewPlansUrl;
      }
      else {

        if (isUnAuth()) {
          sApiUrl = isEffectiveDate ? apiUrl().itpeffectiveDateUrl_ua : apiUrl().itpreviewPlansUrl_ua;
        } else {
          sApiUrl = isEffectiveDate ? apiUrl().itpeffectiveDateUrl : apiUrl().itpreviewPlansUrl;
        }
      }


      return postHttpClientRequest(
        sApiUrl,
        postData,
        axConfig
      );
    }
  }


  callMS(postData, isEffectiveDate)
    .then(msResp => {
      if (msResp && msResp.status == 200) {
        onSuccess(msResp);
      } else {
        onError(msResp, planActions);
      }
    })
    .catch(e => onError(e, planActions));
};
// export const contryListApi = (url, data) => dispatch => {
//   axios({
//     method: 'post',
//     url,
//     data,
//   }).then((response) => {
//     console.log(response.data.data.countryList);
//     dispatch(countryListAction(response.data.data.countryList));
//   }).catch((error) => {
//     console.log(error); // eslint-disable-line
//   });
// };
export const asyncFetch = urlParams => ({
  type: ASYNC_FETCH,
  urlParams
});
export const asyncReviewCallStatus = msResp => ({
  type: ASYNC_FETCH_REVIEW_SUCCESS,
  msResp
});
export const asyncFetchFailed = err => ({
  type: ASYNC_FETCH_FAILURE,
  err
});

/* Generic post API */

// const postAPI = (data, url) => (axios({
//   method: 'post',
//   url,
//   data,
// }));

// export const submitOfferApi = (url, data) => {
//   postAPI(data, url).then(() => {
//     console.log('subMItofeerApi sucess');
//   }).catch((error) => {
//     console.log(error);
//   });
// };

// export const editPlanApi = (url, data) => {
//   postAPI(data, url).then(() => {
//     console.log('editPlanApi sucess');
//   }).catch((error) => {
//     console.log(error);
//   });
// };

export const setReviewDataValue = data => ({
  type: SET_REVIEW_DATA,
  data
});

export const setisReviewLoadValue = data => ({
  type: SET_ISREVIEW_LOAD,
  data
});

export const setisChangePlanValue = data => ({
  type: SET_ISCHANGE_PLAN,
  data
});